<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="false"
    [showFullLogo]="true"
    [title]="''"
    [secondLinkIcon]="themeService.themeMode() === 'dark' ? 'sunny-outline' : 'moon-outline'"
    [showSecondLinkIcon]="true"
    (secondLinkAction)="themeService.toggleTheme()"
    [linkIcon]="'search-outline'"
    [showLinkIcon]="true"
    (linkAction)="openGlobalSearch()" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [hasBottomNav]="!isDesktopRes" [isPrimaryLayer]="true">

    @if (windowService?.isDesktopRes) {
      <tidy-desktop-header [isLoading]="!loaded">
        <div class="wrappable-container">
          <tidy-text
            [title]="'More'" />
          </div>
        <div class="non-wrappable-right-aligned-container">
          <tidy-image
            [src]="themeService.themeMode() | themeIcon"
            class="theme-toggle-icon"
            (click)="themeService.toggleTheme()" />
        </div>
      </tidy-desktop-header>
    }

    @if (loaded) {
      @if (!windowService.isDesktopRes && showLivePill) {
        <tidy-card class="more-live-pill" (click)="openLivePill()">
          <div class="more-live-am">
            <img [src]="managerPhoto" class="more-live-avatar" alt="Account Manager" />
            <div class="more-live-am-text">
              <span class="more-live-eyebrow">Account Manager</span>
              <span class="more-live-name">{{ managerName }}</span>
            </div>
            <span class="more-live-chevron material-icons">chevron_right</span>
          </div>
          <div class="more-live-status">
            @if (!callScheduled && !setupCallCompleted) {
              <div class="more-live-line">
                <span class="more-live-dot amber"></span>
                <span class="more-live-status-text">Schedule Setup Call</span>
              </div>
            } @else {
              <div class="more-live-line">
                <span class="more-live-ring"></span>
                <span class="more-live-status-text"><strong>{{ livePropertiesCount }} of {{ livePropertiesTotal }}</strong> properties live</span>
              </div>
              @if (!setupCallCompleted) {
                <div class="more-live-line">
                  <span class="material-icons more-live-call">call</span>
                  <span class="more-live-status-text">Call scheduled</span>
                </div>
              }
              @if (actionItemsCount > 0) {
                <div class="more-live-line">
                  <span class="more-live-dot amber"></span>
                  <span class="more-live-status-text">{{ actionItemsCount }} action items</span>
                </div>
              }
            }
          </div>
        </tidy-card>
      }
      <div [class]="isEmployeeAccount ? 'one-column-layout' : 'two-column-layout'" [class.more-scrollable-content]="windowService.isDesktopRes">
        <div class="column">
          @if (!isEmployeeAccount && !windowService.isDesktopRes && isRentalClient && matchesSearch(['revenue', 'marketing', 'channels', 'listings', 'website', 'direct booking', 'inquiries', 'reviews', 'upsells', 'wifi', 'happiness', 'optimizer', 'leasing', 'applications', 'tenant', 'screening', 'screenings', 'background check', 'credit check', 'lease', 'rent', 'rent collection', 'long term', 'long-term', 'rooms', 'split', 'by the room', 'roommate', 'room rental'])) {
            <tidy-card>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/marketing.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="'Revenue'" />
              </tidy-row>
              <tidy-card-button (action)="goToListings()">
                <tidy-row>
                  <tidy-text [body]="'Listings'" />
                </tidy-row>
              </tidy-card-button>
              @if (longTermRentals) {
                <tidy-card-button (action)="goToMarketingTab('leasing')">
                  <tidy-row>
                    <tidy-text [body]="'Leasing'" />
                  </tidy-row>
                </tidy-card-button>
                <tidy-card-button (action)="goToLeasingScreenings()">
                  <tidy-row>
                    <tidy-text [body]="'Tenant Screenings'" />
                  </tidy-row>
                </tidy-card-button>
              }
              <tidy-card-button (action)="goToOptimizer()">
                <tidy-row>
                  <tidy-text [body]="'Optimizer'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToMarketingTab('upsells')">
                <tidy-row>
                  <tidy-text [body]="'Upsells'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToUpgrades()">
                <tidy-row>
                  <tidy-text [body]="'Upgrades'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToMarketingTab('reviews')">
                <tidy-row>
                  <tidy-text [body]="'Reviews'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToInquiries()">
                <tidy-row>
                  <tidy-text [body]="'Inquiries'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToDirectBooking()">
                <tidy-row>
                  <tidy-text [body]="'Direct Booking'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToMarketingTab('wifi')">
                <tidy-row>
                  <tidy-text [body]="'Wi-Fi Marketing'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToMarketingTab('happiness')">
                <tidy-row>
                  <tidy-text [body]="'Happiness'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && !windowService.isDesktopRes && isRentalClient && longTermRentals && matchesSearch(['e-sign', 'esign', 'sign', 'signature', 'documents', 'lease'])) {
            <tidy-card>
              <tidy-card-button (action)="goToESign()" class="arrow-to-top">
                <tidy-row class="extra-bottom-padding vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/compliance.svg'"
                    class="title-size" />
                  <tidy-text
                    [header]="'eSignature'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Upload and send documents for signature.'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && !windowService.isDesktopRes && isRentalClient && matchesSearch(['operations', 'messages', 'inbox', 'concierge', 'checklists', 'to-dos', 'restocking', 'inventory', 'assets', 'access', 'upgrades', 'compliance', 'noise', 'monitoring', 'insurance', 'maintenance', 'guidebook', 'guide book', 'pros', 'contacts', 'guests', 'tenants'])) {
            <tidy-card>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/properties.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="'Operations'" />
              </tidy-row>
              <tidy-card-button (action)="goToMessagesPage()">
                <tidy-row>
                  <tidy-text [body]="'Messages'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToToDosPage()">
                <tidy-row>
                  <tidy-text [body]="'Checklists'" />
                </tidy-row>
              </tidy-card-button>
              @if (accountType !== 'Residential') {
                <tidy-card-button (action)="goToInventoryPage()">
                  <tidy-row>
                    <tidy-text [body]="'Restocking'" />
                  </tidy-row>
                </tidy-card-button>
              }
              <tidy-card-button (action)="goToAssetsPage()">
                <tidy-row>
                  <tidy-text [body]="'Assets'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToAccess()">
                <tidy-row>
                  <tidy-text [body]="'Access'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToUpgrades()">
                <tidy-row>
                  <tidy-text [body]="'Upgrades'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToCompliancePage()">
                <tidy-row>
                  <tidy-text [body]="'Compliance'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToNoiseMonitoring()">
                <tidy-row>
                  <tidy-text [body]="'Noise Monitoring'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToInsurance()">
                <tidy-row>
                  <tidy-text [body]="'Insurance'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToMaintenancePage()">
                <tidy-row>
                  <tidy-text [body]="'Maintenance'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToGuidebookPage()">
                <tidy-row>
                  <tidy-text [body]="'Guidebook'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToContactsTab('pros')">
                <tidy-row>
                  <tidy-text [body]="'Pro Contacts'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToContactsTab('guests')">
                <tidy-row>
                  <tidy-text [body]="'Guests/Tenants Contacts'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && !windowService.isDesktopRes && isRentalClient && matchesSearch(['finance', 'bills', 'deposits', 'payments', 'autopay', 'rent', 'leases', 'lease', 'ledger', 'balance', 'rent roll', 'late fee', 'transactions', 'taxes', 'monthly', 'p&l', 'profit', 'loss'])) {
            <tidy-card>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/invoice.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="'Finance'" />
              </tidy-row>
              <tidy-card-button (action)="goToFinanceTab('bills')">
                <tidy-row>
                  <tidy-text [body]="'Bills'" />
                </tidy-row>
              </tidy-card-button>
              @if (longTermRentals) {
                <tidy-card-button (action)="goToFinanceTab('deposits')">
                  <tidy-row>
                    <tidy-text [body]="'Deposits'" />
                  </tidy-row>
                </tidy-card-button>
                <tidy-card-button (action)="goToRentCollection()">
                  <tidy-row>
                    <tidy-text [body]="'Rent Collection'" />
                  </tidy-row>
                </tidy-card-button>
              }
              <tidy-card-button (action)="goToFinanceTab('leases')">
                <tidy-row>
                  <tidy-text [body]="'Leases'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToFinanceTab('transactions')">
                <tidy-row>
                  <tidy-text [body]="'Transactions'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToFinanceTab('taxes')">
                <tidy-row>
                  <tidy-text [body]="'Taxes'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToFinanceTab('monthly')">
                <tidy-row>
                  <tidy-text [body]="'Monthly P&L'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && !windowService.isDesktopRes && accountType === 'Rental' && matchesSearch(['schedule', 'calendar', 'bookings'])) {
            <tidy-card>
              <tidy-card-button (action)="goToSchedulePage()" class="arrow-to-top">
                <tidy-row class="extra-bottom-padding vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/menu-schedule-white.svg'"
                    class="title-size" />
                  <tidy-text
                    [header]="'Schedule'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'See and manage upcoming jobs.'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && !windowService.isDesktopRes && accountType === 'Rental' && matchesSearch(['messages', 'inbox', 'chat', 'concierge'])) {
            <tidy-card>
              <tidy-card-button (action)="goToMessagesPage()" class="arrow-to-top">
                <tidy-row class="extra-bottom-padding vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/menu-messages-white.svg'"
                    class="title-size" />
                  <tidy-text
                    [header]="'Messages'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Inbox of guest, pro, and team conversations.'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && !windowService.isDesktopRes && !isRentalClient && matchesSearch(['checklists', 'to-dos'])) {
            <tidy-card>
              <tidy-card-button (action)="goToToDosPage()" class="arrow-to-top">
                <tidy-row class="extra-bottom-padding vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/checklists.svg'"
                    class="title-size" />
                  <tidy-text
                    [header]="'Checklists'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Manage your checklists.'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          <!-- Finance for rental now lives in the top-of-page Finance section card (with Monthly P&L). -->

          @if (!isEmployeeAccount && !windowService.isDesktopRes && !isRentalClient && matchesSearch(['bills', 'invoice', 'payment'])) {
            <tidy-card>
              <tidy-card-button (action)="goToBillsPage()" class="arrow-to-top">
                <tidy-row class="extra-bottom-padding vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/invoice.svg'"
                    class="title-size" />
                  <tidy-text
                    [header]="'Bills'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Track and pay bills.'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          <!-- Rental Contacts are folded into the Operations card above as Pro Contacts + Guests/Tenants Contacts buttons. -->

          @if (!isRentalClient && !isEmployeeAccount && !windowService.isDesktopRes && matchesSearch(['pros', 'my pros', 'priority', 'manage pros'])) {
            <tidy-card>
              <tidy-card-button (action)="goToContactsTab('pros')">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/pros.svg'"
                    class="title-size" />
                  <tidy-text
                    [header]="'Pros'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && userRole !== 'member' && matchesSearch(['users', 'access', 'share account', 'account access'])) {
            <tidy-card>
              <tidy-card-button (action)="openRightSidePanel('users', UsersPage, {})" class="arrow-to-top">
                <tidy-row class="extra-bottom-padding vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/team.svg'"
                    class="title-size" />
                  <tidy-text
                    [header]="'Users'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Share account access.'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && clientInfo && clientInfo?.customer_account?.account_type !== 'regular' && matchesSearch(['groups', 'teams', 'organize'])) {
            <tidy-card>
              <tidy-card-button (action)="openRightSidePanel('groups', TeamsPage, {})" class="arrow-to-top">
                <tidy-row class="extra-bottom-padding vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/organization.svg'"
                    class="title-size" />
                  <tidy-text
                    [header]="'Groups'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Organize your users and properties.'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && matchesSearch(['account history', 'job history', 'billing history', 'history', 'jobs', 'billing', 'past jobs'])) {
            <tidy-card>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/history.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="'Account History'" />
              </tidy-row>
              <tidy-card-button (action)="goToPastJobs()">
                <tidy-row>
                  <tidy-text
                    [body]="'Job History'" />
                </tidy-row>
              </tidy-card-button>
              @if (userRole !== 'member') {
                <tidy-card-button (action)="goToBillingHistory()">
                  <tidy-row>
                    <tidy-text
                      [body]="'Billing History'" />
                  </tidy-row>
                </tidy-card-button>
              }
            </tidy-card>
          }
          @if (!isEmployeeAccount && userRole !== 'member' && matchesSearch(['payment options', 'payment methods', 'payment settings', 'load credit', 'buy a bundle', 'use a gift card', 'view your current prices', 'payment', 'credit', 'card', 'bundle', 'gift', 'prices'])) {
            <tidy-card>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/credit-card.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="'Payment Options'" />
              </tidy-row>
              <tidy-card-button (action)="openRightSidePanel('payment-methods', PaymentMethodsPage, {})">
                <tidy-row>
                  <tidy-text [body]="'Payment Methods'" /><br />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="openRightSidePanel('payment-methods/load-credit', LoadCreditPage, {})">
                <tidy-row>
                  <tidy-text [body]="'Load Credit'" /><br />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="openRightSidePanel('payment-settings', PaymentSettingsPage, {})">
                <tidy-row>
                  <tidy-text
                    [body]="'Payment Settings'" /><br>
                  @if (settings?.billing?.charge?.type === 'before_cleaning') {
                    <tidy-text
                      [helper]="'Charge in advance (save 10%)'" />
                  }
                  @if (settings?.billing?.charge?.type !== 'before_cleaning') {
                    <tidy-text
                      [helper]="'Charge after jobs are done'" />
                  }
                </tidy-row>
              </tidy-card-button>
              @if (clientInfo?.customer_account?.account_type !== 'rental') {
                <tidy-card-button (action)="openRightSidePanel('buy-bundle', BuyBundlePage, {})">
                  <tidy-row>
                    <tidy-text
                      [body]="'Buy a Bundle (save 10%)'" />
                  </tidy-row>
                </tidy-card-button>
                <tidy-card-button (action)="openRightSidePanel('use-gift-card', UseGiftCardPage, {})">
                  <tidy-row>
                    <tidy-text
                      [body]="'Use a Gift Card'" />
                  </tidy-row>
                </tidy-card-button>
                <tidy-card-button (action)="openRightSidePanel('my-prices', MyPricesPage, {})">
                  <tidy-row>
                    <tidy-text
                      [body]="'View Your Current Prices'" />
                  </tidy-row>
                </tidy-card-button>
              }
            </tidy-card>
          }
        </div>
        <div class="column">
          @if (!isEmployeeAccount && matchesSearch(['integrations', 'airbnb', 'vrbo', 'zapier', 'connect'])) {
            <tidy-card>
              <tidy-card-button (action)="goToIntegrations()" class="arrow-to-top">
                <tidy-row class="extra-bottom-padding vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/integration.svg'"
                    class="title-size" />
                  <tidy-text
                    [header]="'Integrations'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Connect to 100+ integrations'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && !windowService.isDesktopRes && userRole !== 'member' && matchesSearch(['agents', 'automations', 'ai', 'triggers', 'actions', 'workflows'])) {
            <tidy-card>
              <tidy-card-button (action)="goToAgents()" class="arrow-to-top">
                <tidy-row class="extra-bottom-padding vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/agents.svg'"
                    class="title-size" />
                  <tidy-text
                    [header]="'Agents'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Set up agents to automate your work.'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && isRentalClient && matchesSearch(['reports', 'export', 'data'])) {
            <tidy-card>
              <tidy-card-button (action)="goToReports()" class="arrow-to-top">
                <tidy-row class="extra-bottom-padding vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/document.svg'"
                    class="title-size" />
                  <tidy-text
                    [header]="'Reports'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Export data on jobs & more.'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && accountType === 'Rental' && matchesSearch(['reservations', 'guest', 'guests'])) {
            <tidy-card>
              <tidy-card-button (action)="goToGuestReservations()" class="arrow-to-top">
                <tidy-row class="extra-bottom-padding vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/reservations.svg'"
                    class="title-size" />
                  <tidy-text
                    [header]="'Reservations'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'Know when guests come and go.'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (matchesSearch(['account settings', 'contact info', 'subscription', 'account type', 'default backup times', 'backup times', 'account notifications', 'display language', 'my goals', 'default services', 'custom fields', 'settings', 'contact', 'notifications', 'language', 'services', 'fields', 'goals'])) {
            <tidy-card>
              <tidy-row class="extra-bottom-padding vertical-align-center">
                <tidy-image
                  [src]="'assets/img/settings.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="'Account Settings'" />
              </tidy-row>
              <tidy-card-button (action)="openRightSidePanel('contact-info', ContactInfoPage, {})">
                <tidy-row>
                  <tidy-text
                    [body]="'Contact Info'" /><br>
                  @if (clientInfo?.customer_account?.account_name) {
                    <tidy-text
                      [helper]="clientInfo?.customer_account?.account_name" /><br>
                  }
                  <tidy-text
                    [helper]="contactName"
                    [translate]="false" /><br>
                  <tidy-text
                    [helper]="settings?.profile?.email"
                    [translate]="false" /><br>
                  <tidy-text
                    [helper]="settings?.profile?.phone | telephone:'format'" />
                </tidy-row>
                @if (settings?.profile?.phone === null || settings?.profile?.phone === '') {
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/icon/alert-circle-red.svg'"
                      class="body-size" />
                    <tidy-text
                      class="red"
                      [actionBody]="'Missing phone number'" />
                  </tidy-row>
                }
              </tidy-card-button>
              @if (loginEmail && loginEmail !== settings?.profile?.email) {
                <tidy-row>
                  <tidy-text
                    [helper]="'Signed in as '" />
                  <tidy-text
                    [helper]="loginEmail"
                    [translate]="false" />
                </tidy-row>
              }
              @if (!isEmployeeAccount && isRentalClient) {
                <tidy-card-button (action)="openRightSidePanel('subscription', SubscriptionsPage, {})">
                  <tidy-row>
                    <tidy-text
                      [body]="'Subscription'" />
                  </tidy-row>
                </tidy-card-button>
              }
              @if (!isEmployeeAccount) {
                <tidy-card-button (action)="openRightSidePanel('account-type', AccountTypePage, {})">
                  <tidy-row>
                    <tidy-text
                      [body]="'Account Type'" />
                    <br>
                    <tidy-text
                      [helper]="accountType" />
                  </tidy-row>
                </tidy-card-button>
              }
              @if (!isEmployeeAccount && userRole !== 'member') {
                <tidy-card-button (action)="openRightSidePanel('backup-times', BackupTimesPage, {})">
                  <tidy-row>
                    <tidy-text
                      [body]="'Default Backup Times'" />
                    <br>
                    @if (!hasBackupTimes) {
                      <tidy-text
                        [helper]="'None'" />
                    }
                    @for (time of scheduleAssurance?.customerAddress?.times; track time) {
                      @if (time.start_time !== '00:00' && time.start_time !== null) {
                        <tidy-text
                          [helper]="(time.week_day | tweekday: true) + ' '" />
                        <tidy-text
                          [helper]="(time.start_time | parseDateTime: 'h:mma') + ' - ' + (time.end_time | parseDateTime: 'h:mma') + ' '" />
                        <br>
                      }
                    }
                  </tidy-row>
                </tidy-card-button>
                <tidy-card-button (action)="openRightSidePanel('account-notifications', AccountNotificationSettingsPage, {})">
                  <tidy-row>
                    <tidy-text
                      [body]="'Account Notifications'" />
                  </tidy-row>
                  @if (notificationSettings?.length == 0) {
                    <tidy-row>
                      <tidy-text
                        [helper]="'None'" />
                    </tidy-row>
                  }
                  @for (setting of notificationSettings; track setting) {
                    <tidy-row>
                      <tidy-text
                        [helper]="setting?.display_name + ': '" />
                      @for (channel of setting.channels; track channel; let last = $last) {
                        <tidy-text
                          [helper]="channel?.name?.substring(0,37) + (channel?.name?.length > 37 ? '...' : '')" />
                        @if (!last) {
                          <tidy-text
                            [helper]="', '" />
                        }
                      }
                    </tidy-row>
                  }
                </tidy-card-button>
              }
              <tidy-card-button (action)="openRightSidePanel('edit-language', EditLanguagePage, {})">
                <tidy-row>
                  <tidy-text [body]="'Display Language'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text [helper]="language" />
                </tidy-row>
              </tidy-card-button>
              @if (!isEmployeeAccount) {
                <tidy-card-button (action)="openRightSidePanel('service-rename', ServiceRenamePage, {})">
                  <tidy-row>
                    <tidy-text [body]="'Default Services'" />
                  </tidy-row>
                </tidy-card-button>
                <tidy-card-button (action)="goToCustomFields()">
                  <tidy-row>
                    <tidy-text [body]="'Custom Fields'" />
                  </tidy-row>
                </tidy-card-button>
              }
            </tidy-card>
          }
          @if (!isEmployeeAccount && userRole !== 'member' && matchesSearch(['developers', 'api', 'webhooks', 'tidy api'])) {
            <tidy-card>
              <tidy-card-button (action)="openRightSidePanel('more/developers', DevelopersPage, {})" class="arrow-to-top">
                <tidy-row class="extra-bottom-padding vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/web-programming.svg'"
                    class="title-size" />
                  <tidy-text
                    [header]="'Developers'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'TIDY API & webhooks.'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && userRole !== 'member' && matchesSearch(['advanced', 'audit logs', 'bulk upload', 'import', 'export'])) {
            <tidy-card>
              <tidy-row class="extra-bottom-padding vertical-align-center">
                <tidy-image
                  [src]="'assets/img/settings.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="'Advanced'" />
              </tidy-row>
              <tidy-card-button (action)="goToAuditLogs()">
                <tidy-row>
                  <tidy-text
                    [body]="'Audit Logs'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="openRightSidePanel('more/bulk-upload', BulkUploadPage, {})">
                <tidy-row>
                  <tidy-text
                    [body]="'Bulk Upload'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
          @if (!isEmployeeAccount && clientInfo?.customer_account?.account_type !== 'rental' && matchesSearch(['referral code', 'referral', 'code'])) {
            <tidy-card>
              <tidy-row class="extra-bottom-padding vertical-align-center">
                <tidy-image
                  [src]="'assets/img/salary.svg'"
                  class="title-size" />
                <tidy-text
                  [header]="'Referral Code'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="clientInfo?.customer_account?.referral_code" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'Friends who use this get $10 off their first job, then you get $10 off your next.'" />
              </tidy-row>
            </tidy-card>
          }
          @if (matchesSearch(['help', 'support', 'contact support', 'documentation'])) {
            <tidy-card>
              <tidy-row class="extra-bottom-padding vertical-align-center">
                <tidy-image
                  [src]="'assets/img/question.svg'"
                  class="header-size" />
                <tidy-text
                  [header]="'Help'" />
              </tidy-row>
              <tidy-card-button (action)="goToDocumentation()">
                <tidy-row>
                  <tidy-text
                    [body]="'Documentation'" />
                </tidy-row>
              </tidy-card-button>
              <!--<tidy-card-button (action)="goToConcierge()">
                <tidy-row>
                  <tidy-text
                    [body]="'Contact Support'" />
                </tidy-row>
              </tidy-card-button>-->
            </tidy-card>
          }
          <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
            <tidy-text
              [body]="'Cancellation Options'"
              (action)="openRightSidePanel('cancellation-options', CancellationOptionsPage, {})"
              class="link red" />
            <tidy-text
              [body]="'Logout'"
              (action)="logout()"
              class="link demo-allow-action" />
          </tidy-row>
        </div>
      </div>
    }

    @if (!loaded && !windowService.isDesktopRes) {
      <div class="two-column-layout">
        <div class="column">
          <tidy-card>
            <tidy-row>
              <ion-item style="--min-height: 0">
                <ion-skeleton-text animated slot="start" style="width: 35%; height: 16px" />
                <ion-skeleton-text animated slot="end" style="width: 47%; height: 16px" />
              </ion-item>
            </tidy-row>
            <tidy-card-button [hideArrow]="true">
              <tidy-row>
                <ion-skeleton-text animated style="width: 80%" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated style="width: 30%" />
            </tidy-row>
            <tidy-card-button [hideArrow]="true">
              <tidy-row>
                <ion-skeleton-text animated style="width: 60%" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated style="width: 48%" />
            </tidy-row>
            <tidy-card-button [hideArrow]="true">
              <tidy-row>
                <ion-skeleton-text animated style="width: 30%" />
                <ion-skeleton-text animated style="width: 40%" />
              </tidy-row>
            </tidy-card-button>
            <tidy-card-button [hideArrow]="true">
              <tidy-row>
                <ion-skeleton-text animated style="width: 38%" />
                <ion-skeleton-text animated style="width: 68%" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated style="width: 30%" />
            </tidy-row>
            <tidy-card-button [hideArrow]="true">
              <tidy-row>
                <ion-skeleton-text animated style="width: 40%" />
              </tidy-row>
            </tidy-card-button>
            <tidy-card-button [hideArrow]="true">
              <tidy-row>
                <ion-skeleton-text animated style="width: 40%" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
        </div>
        <div class="column">
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated style="width: 45%" />
            </tidy-row>
            <tidy-card-button [hideArrow]="true">
              <tidy-row>
                <ion-skeleton-text animated style="width: 23%" />
              </tidy-row>
            </tidy-card-button>
            <tidy-card-button [hideArrow]="true">
              <tidy-row>
                <ion-skeleton-text animated style="width: 34%" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated style="width: 30%" />
            </tidy-row>
            <tidy-card-button [hideArrow]="true">
              <tidy-row>
                <ion-skeleton-text animated style="width: 40%" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated style="width: 40%" />
            </tidy-row>
            <tidy-card-button [hideArrow]="true">
              <tidy-row>
                <ion-skeleton-text animated style="width: 50%" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated style="width: 30%" />
            </tidy-row>
            <tidy-card-button [hideArrow]="true">
              <tidy-row>
                <ion-skeleton-text animated style="width: 40%" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
        </div>
      </div>
    }

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content" [isfullWidthContent]="isDesktopRes" />

@if (!isDesktopRes) {
  <tidy-bottom-nav activeRoute="/more" />
}



